import(/* webpackMode: "eager" */ "/home/ubuntu/download_staging/6a0687a1f6558f00145c7822_1781736697645_e0e9b886/worldcupcompanion/src/app/not-found.tsx");
